export function validateEmail(email: string): boolean {
    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email)) {
        return false;
    }

    return true;
}

export function validateAustralianBusinessNumber(abn?: string): boolean {
    const cleanAbn: string = abn ? abn.replace(/[^\d]/g, '') : '';

    if (cleanAbn.length !== 11) {
        return false;
    }

    const weights: number[] = [ 10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19 ];
    let sum: number = 0;

    weights.forEach((weight: number, position: number) => {
        let digit: number = Number(cleanAbn[position]);
        if (0 === position) {
            digit--;
        }
        sum += weight * digit;
    });

    return (sum % 89) === 0;
}
